import axiosFile from 'axios';
require('dotenv').config();
const ax = axiosFile.create({ baseURL: `${process.env.REACT_APP_BASE_URL}` });
ax.interceptors.request.use(request => {
  const token = localStorage.getItem('token');
  if (token) request.headers = { 'Authorization': 'Bearer ' + token };
  return request;
}, error => {
  return Promise.reject(error);
});
ax.interceptors.response.use((respuesta) => {
  return respuesta;
}, error => console.log(error));
export default ax;